/**
 * @generated SignedSource<<80f77e4d452ec7a7ea7b945808f3639c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedAddToCartButton_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedShoppingButton_user">;
  readonly " $fragmentType": "PdpSharedAddToCartButton_user";
};
export type PdpSharedAddToCartButton_user$key = {
  readonly " $data"?: PdpSharedAddToCartButton_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedAddToCartButton_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedAddToCartButton_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedShoppingButton_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "9a369e8d3ce46b36c7b5cfdfd9827a15";

export default node;
